import { CommonModule } from "@angular/common";
import { ModuleWithProviders, NgModule } from "@angular/core";
import { MatTooltipModule } from "@angular/material/tooltip";
import { RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";

import { PipesModule } from "@intocare/pipes";
import { IndicatorModule } from "@intocare/ui";

// Services

// Models

// Components
import { ChangelogComponent } from "./components/changelog/changelog.component";
import { RouteNotFoundComponent } from "./components/not-found/not-found.component";
import { GoogleModel } from "./models/google.model";
// Modules
import { CoreDirectivesModule } from "./modules/directives/directive.module";
import { NotFoundModule } from "./modules/not-found/not-found.module";
import { SaveOnExitModule } from "./modules/save-on-exit/save-on-exit.module";
import { BROWSER_PROVIDERS, RouteParamService, ScriptInjectorService, UploadService } from "./services";
import { WindowRef } from "./tokens/window-ref";

export function windowFactory() {
	return window;
}

@NgModule({
	imports: [
		ChangelogComponent,
		CommonModule,
		SaveOnExitModule,
		TranslateModule,
		MatTooltipModule,
		IndicatorModule,
		PipesModule,
		CoreDirectivesModule,
		RouterModule,
		NotFoundModule,
	],
	declarations: [RouteNotFoundComponent],
	exports: [SaveOnExitModule, CoreDirectivesModule, NotFoundModule, RouteNotFoundComponent],
})
export class CoreModule {
	static forRoot(): ModuleWithProviders<CoreModule> {
		return {
			ngModule: CoreModule,
			providers: [
				BROWSER_PROVIDERS,
				ScriptInjectorService,
				UploadService,
				GoogleModel,
				RouteParamService,
				{ provide: WindowRef, useFactory: windowFactory },
			],
		};
	}
}
